export const SearchModal = () => ({
  open: false,

  init() {
    // 監聽自定義事件
    this.$watch('open', (value) => {
      if (value) {
        // 當 modal 開啟時，自動聚焦搜尋輸入框
        this.$nextTick(() => {
          const searchInput = document.getElementById('header_search_q');
          if (searchInput) {
            setTimeout(() => {
              searchInput.focus();
              searchInput.select();
            }, 100);
          }
        });
        
        // 阻止背景滾動
        document.body.style.overflow = 'hidden';
      } else {
        // 恢復背景滾動
        document.body.style.overflow = '';
      }
    });

    // 監聽 Turbo 事件，確保在頁面導航時重新初始化
    document.addEventListener('turbo:load', () => {
      this.open = false;
    });

    document.addEventListener('turbo:before-cache', () => {
      this.open = false;
      document.body.style.overflow = '';
    });
  },

  toggle() {
    this.open = !this.open;
  },

  close() {
    this.open = false;
  },

  handleEscape() {
    this.close();
  },

  handleBackgroundClick() {
    this.close();
  },

  handleFormSubmit() {
    // 表單提交後關閉 modal
    this.close();
  }
});